module.exports = __webpack_public_path__ + "static/media/valentina_guerrero_marin_6.10105a34.jpg";